
import React from "react";
import { Route } from "react-router-dom";
//import { withAuthenticationRequired } from "@auth0/auth0-react";
import ImageLoader from "../common/ImageLoader";

class ProtectedRoute extends React.Component {
    render() {
        const CP = this.props.component;
        return (
            <Route
                render={(props) => {
                    if (this.props.auth0.isAuthenticated && this.props.token !== "") {
                        return <CP {...props} {...this.props} />
                    } else {
                        return <ImageLoader />
                    }

                }
                }
            />
        );
    }
}


export default ProtectedRoute;